export default __webpack_public_path__ + "static/photo-4-da9b0bc14a51fffe0027d2fe4fc790f0.jpg";